import React from 'react'
import CouponsComponent from "../components/CouponsComponent";


export default function Coupons() {
  return (
    <CouponsComponent />
  )
}
